// extracted by mini-css-extract-plugin
export default {"FooterBlock":"_footer_FooterBlock__RV2B9","icons":"_footer_icons__wZBN4"};